export const CREATE_USER_PROFILE_PATH = '/api/v1/user/:userId/profile';
export const SOCIAL_AUTH_PATH = '/api/v1/auth/:identityProvider';

export const DUPLICATE_EMAIL_ERROR_CODE = 203;
